import React, { useContext, useState, useEffect } from 'react'
import { RosterColumn } from '../styles'
import { AllStarContext } from '../../../../../Context'
import { PlayerDataGQL } from '../../../../../Api'
import { PlayerItem } from './PlayerItem'
import { selectPlayersByRosterType } from '../../../../../Utils'
import { Desc } from '../../../../../Components/Typography/Text.styles'
import { colors } from '../../../../../Components/consts'

type RosterParams = {
  rosterType: string
  side: 'left' | 'right'
}

export const RosterAway: React.FC<React.PropsWithChildren<RosterParams>> = ({
  rosterType,
  side,
}) => {
  const [roster, setRoster] = useState<PlayerDataGQL[]>([])
  const { allStarEvent, loading } = useContext(AllStarContext)!

  useEffect(() => {
    filterPlayers()
  }, [allStarEvent])

  const filterPlayers = () => {
    let players = allStarEvent?.awayTeam?.players
    if (!players || players.length < 1) return
    const list = selectPlayersByRosterType(rosterType, players).sort(
      (a, b) => (a?.jerseyNum || 0) - (b?.jerseyNum || 0)
    )
    setRoster(list)
  }

  return (
    <RosterColumn side={side}>
      {roster.length > 0 &&
        roster.map((pl) => (
          <PlayerItem key={pl.officialId} playerInfo={pl} side={side} showAccolade />
        ))}
      {!loading && roster.length === 0 && (
        <Desc textColor={colors.gray.gray20}>No Rosters Available</Desc>
      )}
    </RosterColumn>
  )
}
